<template>
    <v-container fluid class="full-fixed">
        <v-layout align-center justify-center class="transition-centering-y">
            <v-flex xs12 sm8 md6>
                <v-card class="elevation-12">
                    <v-form @submit.prevent="registration">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>{{ $t('registration') }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout wrap>
                                <v-flex md3 px-2 sm6 xs12>
                                    <v-autocomplete :data-vv-as="$t('beneficiary-nature')"
                                                    :item-text="getLabelByLang('name', 'name')"
                                                    :items="beneficiaryNaturesList"
                                                    :error-messages="errors.collect('natureBeneficiary')"
                                                    :label="$t('beneficiary-nature') + ' *'"
                                                    clearable
                                                    item-value="code"
                                                    name="natureBeneficiary"
                                                    v-model="registrationDto.natureBeneficiary"
                                                    v-validate="'required'">
                                        <template slot="selection" slot-scope="data">
                                            {{ $t(data.item.name) }}
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            {{ $t(data.item.name) }}
                                        </template>
                                    </v-autocomplete>
                                </v-flex>

                                <v-flex md2 sm6 xs12 px-2>
                                    <v-text-field v-model="cardidno"
                                                  :data-vv-as="$t('ID-no')"
                                                  :error-messages="errors.collect('ID-no')"
                                                  label="رقم دفتر العائلة *"
                                                  name="cardno"
                                                  v-validate="'required'"></v-text-field>
                                </v-flex>

                                <v-flex md3 px-2 sm6 xs12>
                                    <v-menu :close-on-content-click="false"
                                            :nudge-right="40"
                                            full-width
                                            lazy
                                            min-width="290px"
                                            offset-y
                                            ref="menu"
                                            transition="scale-transition"
                                            v-model="birthDateMenu">
                                        <v-text-field :data-vv-as="$t('birth-date')"
                                                      :error-messages="errors.collect('bod')"
                                                      :label="$t('birth-date') + ' *'"
                                                      clearable
                                                      name="bod"
                                                      prepend-icon="event"
                                                      readonly
                                                      slot="activator"
                                                      v-model="registrationDto.bod"
                                                      v-validate="'required'"></v-text-field>
                                        <v-date-picker @change="birthDateMenu = false"
                                                       min="1900-01-01"
                                                       :max="new Date().toISOString().substr(0, 10)"
                                                       ref="picker"
                                                       v-model="registrationDto.bod"></v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex md3 sm6 xs12 px-2>
                                    <v-text-field v-model="registrationDto.nationalIDNum"
                                                  :data-vv-as="$t('national-Num')"
                                                  :error-messages="errors.collect('nationalIDNum')"
                                                  :label="
                              registrationDto.natureBeneficiary &&
                              registrationDto.natureBeneficiary !== 1
                                ? $t('residence-sequence-number-and-border') + ' *'
                                : $t('beneficiary-nationalNumJOR') + ' *'
                            "
                                                  name="nationalIDNum"
                                                  v-validate="'required|max:10'"
                                                  @change="getNationalInfo($event)"></v-text-field>
                                </v-flex>

                                <v-flex md12 sm6 xs12 px-2>
                                    <v-text-field v-model="registrationDto.arFullName"
                                                  :data-vv-as="$t('full-arabic-name')"
                                                  v-validate="'required'"
                                                  readonly
                                                  :error-messages="errors.collect('arFullName')"
                                                  :label="$t('full-arabic-name')"
                                                  name="arFullName"
                                                  @change="registrationDto.enFullName = registrationDto.arFullName"></v-text-field>
                                </v-flex>

                                <v-flex md4 px-2 sm6 xs12>
                                    <v-autocomplete :data-vv-as="$t('gender')"
                                                    :error-messages="errors.collect('gender')"
                                                    :item-text="'name'"
                                                    :items="gendersList"
                                                    :label="$t('gender')"
                                                    clearable
                                                    readonly
                                                    item-value="code"
                                                    name="gender"
                                                    v-model="registrationDto.gender"
                                                    v-validate="'required'">
                                        <template slot="selection" slot-scope="data">
                                            {{ $t(data.item.name) }}
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            {{ $t(data.item.name) }}
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex md4 px-2 sm6 xs12>
                                    <v-text-field type="Password"
                                                  browser-autocomplete="off"
                                                  :label="$t('password')"
                                                  v-model="registrationDto.password"
                                                  v-validate="'required|min:6'"
                                                  :data-vv-as="$t('password')"
                                                  :error-messages="errors.collect('password')"
                                                  name="password"></v-text-field>
                                </v-flex>
                                <v-flex md4 px-2 sm6 xs12>
                                    <v-autocomplete :data-vv-as="$t('verification-way')"
                                                    :error-messages="errors.collect('verificationMethod')"
                                                    :item-text="'name'"
                                                    :items="verificationWaysList"
                                                    :label="$t('verification-way')"
                                                    clearable
                                                    item-value="code"
                                                    name="verificationMethod"
                                                    v-model="registrationDto.verificationMethod"
                                                    v-validate="'required'">
                                        <template slot="selection" slot-scope="data">
                                            {{ $t(data.item.name) }}
                                        </template>
                                        <template slot="item" slot-scope="data">
                                            {{ $t(data.item.name) }}
                                        </template>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex md8 px-2 sm6 xs12>
                                    <v-text-field :data-vv-as="$t('email')"
                                                  :error-messages="errors.collect('email')"
                                                  :label="$t('email')"
                                                  :name="'email'"
                                                  v-model="registrationDto.email"
                                                  v-validate="'email|max:50'"></v-text-field>
                                </v-flex>
                                <v-flex md8 px-2 sm6 xs12>
                                    <v-text-field :data-vv-as="$t('mobile-number')"
                                                  :error-messages="errors.collect('mobile')"
                                                  :label="$t('mobile-number')"
                                                  :name="'mobile'"
                                                  v-model="registrationDto.mobile"
                                                  v-validate="'required|max:10'">
                                    </v-text-field>
                                </v-flex>
                                <!--<v-flex md4 px-2 sm6 xs12>
                                    <v-autocomplete :data-vv-as="$t('governorate')"
                                                    :error-messages="errors.collect(formScope + '.governorate')"
                                                    :item-text="getLabelByLang('name', 'name')"
                                                    :items="governoratesList"
                                                    :label="$t('governorate') + ' *'"
                                                    clearable
                                                    item-value="code"
                                                    name="governorate"
                                                    v-model="registrationDto.governorate"
                                                    v-validate="'required'"></v-autocomplete>
                                </v-flex>
                                <v-flex md5 px-2 sm6 xs12>
                                    <v-autocomplete :data-vv-as="$t('city')"
                                                    :disabled="isDisabled"
                                                    :error-messages="errors.collect(formScope + '.city')"
                                                    :item-text="getLabelByLang('name', 'name')"
                                                    :items="citiesList"
                                                    :label="$t('city') + ' *'"
                                                    :readonly="isDisabled"
                                                    clearable
                                                    item-value="id"
                                                    name="city"
                                                    v-model="registrationDto.city"
                                                    v-validate="'required'"></v-autocomplete>
                                </v-flex>-->
                            </v-layout>
                        </v-card-text>
                        <v-card-actions class="justify-space-between">
                            <vue-recaptcha :sitekey="siteKey" :loadRecaptchaScript="true" @verify="validate"></vue-recaptcha>
                        </v-card-actions>
                        <v-card-actions class="justify-space-between" v-show="isNotRobot">
                            <v-btn color="error" flat :to="{ name: 'guest-login' }">{{ $t('cancelLogin') }}</v-btn>
                            <v-btn color="success" type="submit">{{ $t('registration') }}</v-btn>
                        </v-card-actions>
                        <!--<v-flex mb-3 px-2>
                            <label>{{ $t('attention-msg') }}</label>
                        </v-flex>-->
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script src="https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit" async defer>
</script>

<script>
    import UserService from '@/services/UserService';
    import LookUpService from '@/services/LookUpService';
    import config from '@/config/config';
    import VueRecaptcha from 'vue-recaptcha';
    import BeneficiaryInformationManagementService from '@/services/Disabilities/PersonWithDisabilities/BeneficiaryInformationManagement/BeneficiaryInformationManagement/BeneficiaryInformationManagementService';

    export default {
        name: 'registration',
        components: { VueRecaptcha },
        data() {
            return {
                registrationDto: {
                    userName: null,
                    arFullName: null,
                    enFullName: null,
                    bod: null,
                    nationalIDNum: null,
                    mobile: null,
                    email: null,
                    companyId: 1,
                    groupId: 1,
                    branchID: 1,
                    source: 4,
                    verificationMethod: null,
                    password: null,
                    gender: null,
                    governorate: null,
                    city: null,
                    natureBeneficiary: null,
                },
                birthDateMenu: false,
                verificationWaysList: [],
                beneficiaryNaturesList: [],
                gendersList: [],
                governoratesList: [],
                citiesList: [],
                isLoading: false,
                formScope: '',
                isDisabled: false,
                isNotRobot: false,
                cardidno: null,
                siteKey: config.reCaptcha.siteKey,
            };
        },
        async created() {
            await this.getBeneficiaryNatures();
            await this.verificationWaysInit();
            await this.gendersInit();
            await this.getGovernorates();
            await this.getCities();
            if (window.location.href.includes("10.196.11.59") || window.location.href.includes("10.196.11.61")) {
                this.isNotRobot = true;
            }
        },
        methods: {
            async emailChanged() {
                this.registrationDto.userName = this.registrationDto.mobile;
                if (await this.$validator.validate('email')) {
                    this.isLoading = true;
                    await this.getUserByEmail();
                    this.isLoading = false;
                }
            },
            async getNationalInfo(nationalNumber) {
                this.isLoading = true;
                this.$store.dispatch('showLoading');
                if (this.registrationDto.natureBeneficiary === 1) {
                    var beneficiaryInformationManagement = (await BeneficiaryInformationManagementService.GetCSPDInfoBYNationalNum(nationalNumber, this.cardidno, this.registrationDto.bod.toString())).data;
                    if (beneficiaryInformationManagement) {
                        if (!beneficiaryInformationManagement.bod.includes("0001")) {
                            this.registrationDto.arFullName = beneficiaryInformationManagement.fullName;
                            this.registrationDto.gender = beneficiaryInformationManagement.gender;
                            this.registrationDto.bod = beneficiaryInformationManagement.bod.substr(0, 10);
                        }
                        else {
                            this.$store.dispatch('showMessage', {
                                text: 'خطأ فى البيانات',
                                color: 'error'
                            });
                        }
                    }
                }
                this.$store.dispatch('hideLoading');
                this.isLoading = false;
            },
            verificationWaysInit() {
                this.verificationWaysList = [
                    {
                        code: 2,
                        name: 'SMS'
                    },
                    {
                        code: 1,
                        name: 'email'
                    }
                ];
            },
            gendersInit() {
                this.gendersList = [
                    {
                        code: '1',
                        name: 'male'
                    },
                    {
                        code: '2',
                        name: 'female'
                    }
                ];
            },
            getBeneficiaryNatures() {
                this.beneficiaryNaturesList.push(
                    {
                        code: 1,
                        name: 'jordanian'
                    },
                    {
                        code: 2,
                        name: 'non-jordanian'
                    },
                );
            },
            async getGovernorates() {
                this.governoratesList = (await LookUpService.getLookup(62)).data;
            },
            async getCities() {
                this.citiesList = (await LookUpService.getLookup(100)).data;
            },
            async registration() {
                const isValid = await this.$validator.validateAll();
                if (!isValid) return;
                const rawFile = new XMLHttpRequest();
                rawFile.open('GET', '/company.json', false);
                rawFile.onreadystatechange = () => {
                    if (rawFile.readyState === 4) {
                        if (rawFile.status === 200 || rawFile.status == 0) {
                            const allText = rawFile.response;
                            this.registrationDto.companyId = JSON.parse(allText).companyId;
                        }
                    }
                };

                rawFile.send(null);
                const rawBranchFile = new XMLHttpRequest();
                rawBranchFile.open('GET', '/branch.json', false);
                rawBranchFile.onreadystatechange = () => {
                    if (rawBranchFile.readyState === 4) {
                        if (rawBranchFile.status === 200 || rawBranchFile.status == 0) {
                            const allText = rawBranchFile.response;
                            this.registrationDto.branchID = JSON.parse(allText).branchID;
                        }
                    }
                };

                rawBranchFile.send(null);
                this.isLoading = true;
                await this.saveUser();
                this.isLoading = false;
            },

            async saveUser() {
                this.registrationDto.userName = this.registrationDto.mobile;
                const result = (await UserService.saveUser(this.registrationDto)).data;
                if (result.statusCode === 200) {
                    this.$store.dispatch('showMessage', { text: result.message });
                    this.$router.push({ name: 'verification', params: { from: '2', id: result.id } });
                } else
                    this.$store.dispatch('showMessage', {
                        text: result.message,
                        color: 'error'
                    });
            },

            validate(success) {
                this.isNotRobot = success;
            }
        }
    };
</script>
